import { create } from 'zustand';
import type { Hero } from '../game/data/heroes';

// One global slot for "which hero is the player inspecting".
//
// Sibling of stores/cardDetail.ts and deliberately separate rather than a
// union on that store: a card and a hero share almost no fields (tier /
// attack / health / rules text vs power description / cost / faction), so a
// combined store would be a discriminated union that every consumer has to
// narrow before it can read anything. Two small stores, two hosts, no
// narrowing.
//
// This exists because hero art is now shown in TWO forms. The in-game tile
// renders the square bust derivative (see components/portraitArt.ts), which
// is the only way a face reads at tile size — but that crop throws away the
// full-page drawing, which is the actual piece of art. The lightbox is where
// the page gets shown whole.
//
// Deliberately NOT persisted: an open lightbox is transient view state and
// should never survive a reload.

interface HeroDetailState {
  hero: Hero | null;
  open: (hero: Hero) => void;
  close: () => void;
}

export const useHeroDetailStore = create<HeroDetailState>((set) => ({
  hero: null,
  open: (hero) => set({ hero }),
  close: () => set({ hero: null }),
}));
